import React, { useState } from 'react';

import { ToggleButtonGroup, ToggleButton } from '@gogame/components';

import { useCreative } from 'scenes/Gallery/GalleryPage/Creatives/data';

import { useConcept } from 'scenes/Gallery/GalleryPage/Concepts/data';

import PrefillFieldsDialog from 'scenes/Gallery/components/PrefillFieldsDialog';

const ID = 'ID';
const KEY = 'Key';

const CreativePrefillFieldsDialog = ({ open, onSubmit, onExited, onClose }) => {
  const [searchMode, setSearchMode] = useState(ID);
  const [creativeId, setCreativeId] = useState('');

  const {
    data: creativeData,
    isLoading: loadingCreativeData,
    error: errorCreative,
  } = useCreative(
    { id: searchMode === KEY ? parseInt(creativeId, 36) : creativeId },
    { enabled: Boolean(creativeId) }
  );

  const {
    data: conceptData,
    isLoading: loadingConcept,
    error: errorConcept,
  } = useConcept(
    { id: creativeData?.conceptId },
    { enabled: Boolean(creativeData?.conceptId) }
  );

  const handleChangeCreativeId = (_, value) => {
    setCreativeId(value);
  };

  const handleSubmit = () => {
    onSubmit({ creativeData, conceptData });
  };

  const handleChangeSearchMode = (_, value) => {
    setSearchMode(value);
  };

  return (
    <PrefillFieldsDialog
      controls={
        <ToggleButtonGroup value={searchMode} onChange={handleChangeSearchMode}>
          <ToggleButton value={ID}>{ID}</ToggleButton>
          <ToggleButton value={KEY}>{KEY}</ToggleButton>
        </ToggleButtonGroup>
      }
      title={`Enter the ${searchMode} of the Creative to prefill fields from.`}
      filedLabel={searchMode}
      open={open}
      onSubmit={handleSubmit}
      onExited={onExited}
      onClose={onClose}
      id={creativeId}
      onChangeId={handleChangeCreativeId}
      disabledConfirmAction={
        !(creativeData && conceptData) || loadingCreativeData || loadingConcept
      }
      error={Boolean(errorCreative || errorConcept)}
    />
  );
};

export default CreativePrefillFieldsDialog;
